<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Admin Event Dashboard</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row class="pt-10" justify="center">
          <v-card class="box filter-box">
            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
                <b class="ml-3">Event State</b
                ><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                <v-radio-group
                  v-model="radios"
                  mandatory
                  row
                  class="ma-2 no-display"
                >
                  <v-radio label="All" value="all" color="#0f2027"></v-radio>
                  <v-radio
                    label="Active"
                    value="active"
                    color="#0f2027"
                  ></v-radio>
                  <v-radio
                    label="Inactive"
                    value="inactive"
                    color="#0f2027"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <b>Event</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                <v-autocomplete
                  dense
                  v-model="selectedEvent"
                  :items="filteredEvents"
                  item-text="name"
                  item-value="id"
                  name="Event"
                  return-object
                  outlined
                  hint="Please select the event"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="mt-9">
                <v-btn class="info" v-model="fetch" @click="showSelectedEvent"
                  >Fetch</v-btn
                >
              </v-col>
            </v-row>
          </v-card>
        </v-row>
        <v-row justify="center" class="pt-10">
          <v-btn class="button1 mr-8" color="primary" @click="addEvent()"
            >Add Event</v-btn
          >
        </v-row>
      </v-card>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-form v-model="valid">
            <v-card-title class="toolbar">
              <span class="headline">Add event</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <b>Event Name</b
                    ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                    <v-text-field
                      v-model="name"
                      dense
                      :rules="[(v) => !!v || 'Event Name is required']"
                      hint="For ex. PTM-Dec-2024..."
                      outlined
                    ></v-text-field>
                  </v-col>

                  <!-- From Date -->

                  <v-col cols="12" sm="12" md="12">
                    <b>From Date</b
                    ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                    <v-datetime-picker
                      v-model="from_date_time"
                      dateFormat="dd-MM-yyyy"
                      outlined
                    ></v-datetime-picker>
                  </v-col>

                  <!-- To Date -->
                  <v-col cols="12" sm="12" md="12">
                    <b>To Date</b
                    ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                    <v-datetime-picker
                      v-model="to_date_time"
                      dateFormat="dd-MM-yyyy"
                      outlined
                    ></v-datetime-picker>
                  </v-col>

                  <!-- Description -->
                  <v-col cols="12" sm="12" md="12">
                    <b>Description</b>
                    <v-text-field v-model="description" outlined></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mb-2 button" text @click="closeDialog"
                >Cancel</v-btn
              >
              <v-btn class="mb-2 button" :disabled="!isFormValid" @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_edit" max-width="500px">
        <v-card class="box">
          <v-card-title class="toolbar">
            <span class="headline"> Edit Event</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- Event Name -->
                <v-col cols="12" sm="12" md="12">
                  <b>Event Name</b
                  ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="[(v) => !!v || 'Event Name is required']"
                    hint="For ex. PTM-Dec-2024..."
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- From Date -->

                <v-col cols="12" sm="12" md="12">
                  <b>From Date</b
                  ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                  <v-datetime-picker
                    v-model="editedItem.from_date_time"
                    dateFormat="dd-MM-yyyy"
                    outlined
                  ></v-datetime-picker>
                </v-col>

                <!-- To Date -->
                <v-col cols="12" sm="12" md="12">
                  <b>To Date</b
                  ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                  <v-datetime-picker
                    v-model="editedItem.to_date_time"
                    label="To Date"
                    dateFormat="dd-MM-yyyy"
                    outlined
                  ></v-datetime-picker>
                </v-col>

                <!-- Description -->
                <v-col cols="12" sm="12" md="12">
                  <b>Description</b>
                  <v-text-field
                    v-model="editedItem.description"
                    outlined
                  ></v-text-field>
                </v-col>

                <!-- Active Checkbox -->
                <v-col cols="12" sm="6" md="4">
                  <v-checkbox
                    v-model="editedItem.isactive"
                    color="success"
                    label="Active"
                    dense
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mb-2 button" text @click="edit()">Save</v-btn>
              <v-btn class="mb-2 button" text @click="dialog_edit = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-row>
        </v-card>
      </v-dialog>
      <v-card v-if="fetch" class="box">
        <v-data-table :headers="headers" :items="fetchedEvent">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Events</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item.description="{ item }">
            <v-icon
              v-if="item.description"
              @click="openDescDialog(item.description)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            >
            <span v-else>--</span>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="d-flex align-center">
              <v-switch
                color="success"
                class="mr-3"
                v-model="item.isactive"
                @change="isActive(item)"
              ></v-switch>
              <v-avatar style="" size="20" class="edit-avatar">
                <v-icon class="edit-v-icon mr-4" @click="editItem(item)"
                  >edit</v-icon
                >
              </v-avatar>
              <v-avatar style="" size="20" class="edit-avatar">
                <v-icon
                  color="error"
                  class="delete-v-icon ml-2"
                  @click="deleteItem(item)"
                  >delete</v-icon
                >
              </v-avatar>
              <v-icon color="black" class="ml-4" @click="getEventDetails(item)"
                >mdi mdi-view-dashboard</v-icon
              >
            </div>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="descDialog" max-width="400">
        <v-card>
          <v-card-title
            >Description <v-spacer></v-spacer
            ><v-icon @click="close">mdi-close</v-icon></v-card-title
          >
          <v-divider></v-divider>
          <v-card-text class="pb-0 pr-2">
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="12" md="12" class="pb-6 pt-3" align="center">
                <b style="font-size: 17px"> {{ selectedDesc }} </b>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datetime from "vuejs-datetimepicker";
import moment from "moment";
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    Datepicker,
    datetime,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    name: "",
    description: "",
    from_date_time: null,
    to_date_time: null,
    descDialog: false,
    dialog_edit: false,
    selectedDesc: "",
    headers: [
      { text: "Sr.No.", value: "srno" },
      { text: "Event Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "From Date & Time", value: "from_date_time" },
      { text: "To Date & Time", value: "end_date_time" },
      { text: "Actions", value: "action" },
    ],
    selectedEvent: { name: "All", id: null },
    event_list: [],
    fetch: false,
    dialog: false,
    isactive: true,
    radios: null,
    fetchedEvent: null,
    instructor_list: [],
    event_booking_status_list: [],
    stream_list: [],
    ay_id: null,
    standard_list_all: [],
    valid: false,
    editedItem: {
      id: "",
      name: "",
      from_date_time: null,
      to_date_time: null,
      description: "",
      isactive: true,
    },
  }),
  computed: {
    filteredEvents() {
      if (this.radios === "all") {
        return this.event_list;
      } else if (this.radios === "active") {
        return this.event_list.filter((event) => event.isactive);
      } else if (this.radios === "inactive") {
        return this.event_list
          .filter((event) => !event.isactive)
          .filter((event) => event.name != "All");
      }
      return this.event_list;
    },
    isFormValid() {
      return this.name && this.from_date_time && this.to_date_time;
    },
  },
  methods: {
    showSelectedEvent() {
      // alert(this.selectedEvent.name+" "+this.selectedEvent.id)
      this.fetch = true;
      if (this.selectedEvent) {
        if (this.selectedEvent.name == "All") {
          this.fetchedEvent = this.event_list.filter(
            (event) => event.name != "All"
          );
        } else {
          this.fetchedEvent = [
            {
              ...this.selectedEvent,
            },
          ];
        }
      } else {
        this.fetchedEvent = [];
      }
      this.onload();
    },
    addEvent() {
      this.dialog = true;
    },
    openDescDialog(desc) {
      this.selectedDesc = desc;
      this.descDialog = true;
    },
    close() {
      this.descDialog = false;
    },
    resetForm(){
      this.description = "";
      this.to_date_time = null;
      this.from_date_time = null;
      this.name = "";
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // }, 300);
    },
    save() {
      var from_date_time = moment(this.from_date_time).format(
        "YYYY-MM-DD HH:mm"
      );
      var to_date_time = moment(this.to_date_time).format("YYYY-MM-DD HH:mm");
      const eventData = {
        from_date_time: from_date_time,
        to_date_time: to_date_time,
        name: this.name,

        description: this.description,
        isactive: this.isactive,
      };

      axios
        .post("/Appointment/saveEvent", eventData) 
        .then((res) => {
          if (res.data.code === "SUCCESS") {

            this.showSnackbar("#4caf50", "Event Added Successfully...");

            this.onload();
            this.name = null;

            this.description = "";
          } else if (res.data.code === "NA") {
            this.showSnackbar("#b71c1c", "Event Already Present!!!");
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.name = null;

          this.description = "";
        });
      this.closeDialog();
    },
    edit() {
      var from_date_time = moment(this.editedItem.from_date_time).format(
        "YYYY-MM-DD HH:mm"
      );
      var to_date_time = moment(this.editedItem.to_date_time).format(
        "YYYY-MM-DD HH:mm"
      );
      // Create event data object
      const data = {
        from_date_time: from_date_time,
        to_date_time: to_date_time,
        name: this.editedItem.name,

        description: this.editedItem.description,
        isactive: this.editedItem.isactive,
        id: this.editedItem.id,
      };
      axios
        .post("/Appointment/editEvent", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.onload();
            this.dialog_edit = false;
            this.showSnackbar("#4caf50", "Event  Updated Successfully..."); // show snackbar on success
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
    },
    editItem(Item) {
      const data = {
        event_id: Item.id,
      };
      axios
        .post("/Appointment/getdatafromevent", data)
        .then((res) => {
          if (res.data.flag === "Yes") {
            this.editedItem = res.data.event_details[0];

            // Replace 'PM' with 'PM' if necessary and remove seconds if they are included
            const fromDateTimeString = this.editedItem.from_date_time.replace(
              " PM",
              " PM"
            ); // Adjust if necessary
            const endDateTimeString = this.editedItem.end_date_time.replace(
              " PM",
              " PM"
            ); // Adjust if necessary

            // Use moment to parse the dates with the appropriate format
            const momentFromDate = moment(
              fromDateTimeString,
              "YYYY-MM-DD hh:mm A"
            );
            const momentToDate = moment(
              endDateTimeString,
              "YYYY-MM-DD hh:mm A"
            );

            // Check if moment returned valid dates
            if (momentFromDate.isValid() && momentToDate.isValid()) {
              this.editedItem.from_date_time = momentFromDate.toDate(); // Set the date object
              this.editedItem.to_date_time = momentToDate.toDate(); // Set the date object
            } else {
              // Handle invalid date format, maybe log an error or set to null
              console.error(
                "Invalid date format:",
                fromDateTimeString,
                endDateTimeString
              );
              this.editedItem.from_date_time = null;
              this.editedItem.to_date_time = null;
            }

            this.dialog_edit = true;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getEventDetails(item) {
        let routeData = this.$router.resolve({ name: "admin-event-dashboard-report" });
        window.open(routeData.href, "_blank"); 
        localStorage.setItem("ay_id", this.ay_id);
        localStorage.setItem("selected-event", JSON.stringify(item));
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    isActive(item) {
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Appointment/toggleEvent", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Event Status Changed!");
            this.getEvent();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            );
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getEvent() {
      this.overlay = true;
      axios
        .post("/Appointment/getEvent")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.event_list = res.data.event_list;
              this.instructor_list = res.data.instructor_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    deleteItem(item) {
      if (!confirm("Are You Sure You Want To Delete Event ...?")) return;
      const formData = {
        id: item.id,
      };
      axios.post("/Appointment/deleteEvent", formData).then((res) => {
        if (res.data.status == "YES") {
          this.showSnackbar("#4caf50", "Event Delete Successfully...");
          this.onload();
        } else {
          this.showSnackbar("#b71c1c", "Something went wrong...");
        }
      });
    },
    onload() {
      axios
        .post("Appointment/adminEventDashboardHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showSnackbar("success","Data fetched successfully !!!")
            this.event_list = res.data.event_list;
            this.ay_id = res.data.ay_id;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
  watch: {},
};
</script>
<style scoped>
.filter-box {
  width: 50% !important;
}
</style>